<div class="w-full  sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">


<!--#######################################-->
<form [formGroup]="casosForm" *ngIf="data.type === 'create'" class="w-full">

    <!--############################################################-->
<div class="bg-white rounded-lg p-4">
    <!-- ##########################################################  -->
    <!-- ##########################################################  -->
    <div class="w-full">
        <!-- ##########################################################  --> 
        <div class="grid grid-cols-10">   
            <div class="col-span-8">
                <!-- ## -->
                    <h2 class="prose prose-xl"><b> Crear Disputa {{frienlyEomOrder}}</b></h2>                       
                    <h2 class="prose ">  SKU <b>{{codPsServices}}</b> {{namePsServices}} </h2>   
                <!-- ## -->
            </div>
            <div class="col-span-1">
                <!-- ## -->
                <button class="close " mat-button (click)="closeBtn()"> <mat-icon>close</mat-icon></button>    
                <!-- ## -->
            </div>
        </div>
        <!-- ##########################################################  -->    

    </div>
<!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->
<mat-divider class="py-2"></mat-divider>
<!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%  -->


 <mat-card >   
    <!-- 
    <div *ngIf="flagShowCustomer == true">
        <mat-form-field class="w-1/2">
            <mat-label> Cliente</mat-label>
            <mat-select formControlName="customer">
                <ng-container *ngFor="let customer of customerList">
                    <mat-option [value]="customer.UUID_CRM_CUSTOMER">
                        {{ customer.RUT || '1-9' | rut:'DOTS_DASH'  }} {{ customer.CUSTOMER_FANCY_NAME }}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>
    -->
    <mat-card-content>    
    <!--#######################################-->
    <div *ngIf="flagShowCustomer == true">
        <button class="ml-4" mat-flat-button [color]="'primary'" (click)="showSupplier()">
            <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
            <span class="ml-2 mr-1"> Selecione Cliente </span>
        </button>
    </div>
    <!--#######################################-->  
    <br>  
    <div *ngIf="flagShowCustomerName == true">
        <div  class="text-3xl font-extrabold tracking-tight">{{customerRut || '1-9' | rut:'DOTS_DASH'}} {{customerFancyName}} </div>
    </div>
    <!--#######################################-->  

                                <div class="">
                                    <mat-form-field appearance="fill" class="w-1/2  fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix selecet form-gen">
                                        <mat-label>Contacto</mat-label>
                                        <mat-select  formControlName="uuidCrmCustomerContact" (selectionChange)="setContactoReceptorMail($event.value)">
                                            <ng-container *ngFor="let f of customerRelatedContact">
                                                <mat-option [value]="f.UUID_CRM_CUSTOMER_CONTACT">{{f.FIRST_NAME}} {{f.LAST_NAME}}</mat-option>
                                            </ng-container> 
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field appearance="fill" class="w-1/3  fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix selecet form-gen">
                                        <mat-label> Correo Contacto</mat-label>
                                        <input matInput  formControlName="contactoReceptorMail" readonly>
                                        <mat-icon matSuffix> alternate_email </mat-icon>
                                    </mat-form-field>     
                                    <div class="buttons" *ngIf="flagValid == true">
                                        <button mat-button color="primary" (click)="createContact()" > Crear Contacto </button>
                                    </div>                               
                                </div>                        
    <!--#######################################--> 

    <div class="flex">
        <mat-form-field class="w-1/2">
            <mat-label> T1 </mat-label>
            <mat-select formControlName="t1">
                <ng-container *ngFor="let t1 of t1List">
                    <mat-option [value]="t1.ID_CM_INTERACTION_T1" (click)="t1Selected()">
                        {{ t1.T1 }}
                    </mat-option>
                </ng-container> 
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-1/2">
            <mat-label> T2 </mat-label>
            <mat-select formControlName="t2">
                <ng-container *ngFor="let t2 of t2ListFiltered">
                    <mat-option [value]="t2" (click)="t2Selected(t2)">
                        {{ t2.T2 }}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>
    <form [formGroup]="flexibleAttributesForm" class="flex w-full" *ngIf="flexibleAttributesFiltered">
        <mat-form-field *ngFor="let fa of flexibleAttributesFiltered" class="w-1/2">
            <mat-label> {{fa.NAME_PARAM}} </mat-label>
            <input 
                #number 
                *ngIf="fa.TYPE_PARAM === 'NUMBER'" 
                matInput 
                type="number" 

                [formControlName]="fa.NAME_PARAM_FORM" 
                [min]="fa.MIN_LENGTH_PARAM" 
                [max]="fa.MAX_LENGTH_PARAM">

            <input 
                *ngIf="fa.TYPE_PARAM === 'DATE'"
                matInput 
                type="date"
                [formControlName]="fa.NAME_PARAM_FORM">

            <input 
                *ngIf="fa.TYPE_PARAM === 'DATE_TIME'"
                matInput
                type="date"
                [formControlName]="fa.NAME_PARAM_FORM">

            <input 
                *ngIf="fa.TYPE_PARAM === 'VARCHAR'" 
                matInput 
                type="text"
                [formControlName]="fa.NAME_PARAM_FORM"
                [minlength]="fa.MIN_LENGTH_PARAM" 
                [maxlength]="fa.MAX_LENGTH_PARAM">
            
            <input 
            *ngIf="fa.TYPE_PARAM === 'AMOUNT'" 
            matInput 
            type="text"
            [formControlName]="fa.NAME_PARAM_FORM">
                
            <mat-select *ngIf="fa.TYPE_PARAM === 'LIST'" [formControlName]="fa.NAME_PARAM_FORM">
                <ng-container *ngFor="let list of fa.LIST_VALUES_PARAM.value">
                    <mat-option [value]="list.id">
                        {{list.value}}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </form>
    <div>
        <!-- <h1> SLA {{casosForm.value.t2}}</h1> -->
    </div>
        <!-- ESTADO -->
        <mat-form-field class="w-1/3">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="status" (selectionChange)="getAnswer($event.value)">
                <mat-option *ngFor="let stat of status" [value]="stat.ID_CM_INTERACTION_STATUS">
                    {{ stat.NAME_CM_INTERACTION_STATUS }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <!-- ============================================ -->
            <div *ngIf="answerUse.length > 0">

                <mat-form-field class="w-1/3">
                    <mat-label>Respuesta Sugerida</mat-label>
                    <mat-select  (selectionChange)="setAnswer($event.value)">
                        <mat-option *ngFor="let a of answerUse" [value]="a">
                            {{ a.INTERACTION_TITLE }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        <!-- ============================================ -->   


    <mat-form-field class="w-full">
        <mat-label>Descripción del caso</mat-label>
        <textarea matInput formControlName="txt" #txt maxlength="500" cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="15" class="leading-5"></textarea>
        <mat-hint align="end">{{txt.value?.length || 0}}/500</mat-hint>
    </mat-form-field>
    <!-- {{flexibleAttributesForm.invalid}} -->
    <button 
        mat-raised-button color="primary"
        [disabled]="casosForm.invalid || flexibleAttributesForm.invalid" 
        (click)="create()">
        Crear Caso
    </button>
</mat-card-content>
</mat-card >  
</div>  
</form>

<!-- ############################################################## -->

<form [formGroup]="casosForm" *ngIf="data.type === 'update'" class="w-full">

    <div class="bg-white dark:bg-gray-900 rounded-xl p-6 shadow-sm space-y-6">

        <!-- ENCABEZADO -->
        <div class="grid grid-cols-12 items-start">
            
            <div class="col-span-11 space-y-1">
                <h2 class="text-2xl font-semibold">Caso <span class="font-bold">{{ interaction.COD_CUSTOMER_INTERACTION }}</span></h2>
                <h3 class="text-lg text-gray-700 dark:text-gray-300">
                    Cliente:
                    <b>{{ interaction.RUT || '1-9' | rut:'DOTS_DASH' }} {{ interaction.CUSTOMER_FANCY_NAME }}</b>
                </h3>
            </div>
            <div>
                 <h2 class="prose prose-xl"><b> Crear Disputa {{frienlyEomOrder}}</b></h2>                       
                 <h2 class="prose ">  SKU <b>{{codPsServices}}</b> {{namePsServices}} </h2>   
            </div>
            <div class="col-span-1 flex justify-end">
                <button mat-icon-button  (click)="closeBtn()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <mat-divider></mat-divider>

        <!-- SLA & DETALLES -->
        <div class="grid grid-cols-12 gap-4 text-gray-800 dark:text-gray-200">

            <div class="col-span-4 flex items-center gap-2">
                <mat-icon
                    [ngStyle]="{
                        color: interaction.SLA_LIGHT === 0 ? '#008f39' :
                               interaction.SLA_LIGHT === 1 ? '#e5be01' :
                                                             '#e01601'
                    }"
                >flag</mat-icon>

                <span class="font-medium">
                    {{
                        interaction.SLA_LIGHT === 0 ? 'En plazo' :
                        interaction.SLA_LIGHT === 1 ? 'Por vencer' : 'Vencido'
                    }}
                </span>
            </div>

            <div class="col-span-4">
                SLA: <b>{{ interaction.SLA }} horas</b>
            </div>

            <div class="col-span-4">
                Valor del Cliente: <b>{{ interaction.NAME_CM_CUSTOMER_VALUE }}</b>
            </div>

            <div class="col-span-4">
                Creado: <b>{{ interaction.DATE_CREATION | date:'medium' }}</b>
            </div>

            <div class="col-span-4"></div>

            <div class="col-span-4">
                Cerrado:
                <b *ngIf="interaction.FLAG_END === 'Y'">{{ interaction.DATE_CLOSE | date:'medium' }}</b>
                <b *ngIf="interaction.FLAG_END === 'N'">Sin resolver</b>
            </div>

            <div class="col-span-12 pt-2">
                Asignado a:
                <b>{{ interaction.EMPLOYEE_FIRST_NAME }} {{ interaction.EMPLOYEE_LAST_NAME }}</b>
            </div>
        </div>

        <!-- CAMPOS OCULTOS -->
        <mat-form-field class="w-1/2 hidden">
            <mat-label>Cliente</mat-label>
            <mat-select formControlName="customer" disabled>
                <mat-option *ngFor="let customer of customerList" [value]="customer.UUID_CRM_CUSTOMER">
                    {{ customer.CUSTOMER_FIRST_NAME }} {{ customer.CUSTOMER_LAST_NAME }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    <!--#######################################-->  

                                <div class="">
                                    <mat-form-field appearance="fill" class="w-1/2  fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix selecet form-gen">
                                        <mat-label>Contacto</mat-label>
                                        <mat-select  formControlName="uuidCrmCustomerContact" (selectionChange)="setContactoReceptorMail($event.value)">
                                            <ng-container *ngFor="let f of customerRelatedContact">
                                                <mat-option [value]="f.UUID_CRM_CUSTOMER_CONTACT">{{f.FIRST_NAME}} {{f.LAST_NAME}}</mat-option>
                                            </ng-container> 
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field appearance="fill" class="w-1/3  fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix selecet form-gen">
                                        <mat-label> Correo Contacto</mat-label>
                                        <input matInput  formControlName="contactoReceptorMail" readonly>
                                        <mat-icon matSuffix> alternate_email </mat-icon>
                                    </mat-form-field>     
                                    <div class="buttons" *ngIf="flagValid == true">
                                        <button mat-button color="primary" (click)="createContact()" > Crear Contacto </button>
                                    </div>                               
                                </div>                        
    <!--#######################################-->
        <!-- CAMPOS T1/T2 -->
        <div class="grid grid-cols-2 gap-4">
            <mat-form-field class="w-full">
                <mat-label>T1</mat-label>
                <input matInput readonly formControlName="t1"/>
            </mat-form-field>

            <mat-form-field class="w-full">
                <mat-label>T2</mat-label>
                <input matInput readonly formControlName="t2"/>
            </mat-form-field>
        </div>

        <!-- ESTADO -->
        <mat-form-field class="w-1/3">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="status" (selectionChange)="getAnswer($event.value)">
                <mat-option *ngFor="let stat of status" [value]="stat.ID_CM_INTERACTION_STATUS">
                    {{ stat.NAME_CM_INTERACTION_STATUS }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <!-- ============================================ -->
            <div *ngIf="answerUse.length > 0">

                <mat-form-field class="w-1/3">
                    <mat-label>Respuesta Sugerida</mat-label>
                    <mat-select  (selectionChange)="setAnswer($event.value)">
                        <mat-option *ngFor="let a of answerUse" [value]="a">
                            {{ a.INTERACTION_TITLE }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        <!-- ============================================ -->         
        <mat-divider></mat-divider>
            <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% -->
             <div  *ngIf="interaction.FLAG_END == 'Y'">
                 <mat-tab-group #tabsOrder  [selectedIndex]="matTabOrderSelected">
                      <!-- ##########################################################  -->
                           <mat-tab label="Interacciones previas" >
                                <mat-divider class="py-2"></mat-divider>
                                <!-- ** -->
                                    <div class="space-y-4">
                                        <mat-card *ngFor="let desc of interaction.J_CUSTOMER_INTERACTION" class="interaction-card">
                                            <mat-card-header>
                                                <mat-card-title class="text-base font-medium flex items-center gap-2">
                                                    <mat-icon svgIcon="person" class="opacity-70"></mat-icon>
                                                    {{ desc.by }}
                                                </mat-card-title>
                                                <mat-card-subtitle>{{ desc.date | date:'medium' }}</mat-card-subtitle>
                                            </mat-card-header>

                                            <mat-card-content>
                                                <p class="leading-relaxed text-gray-700 dark:text-gray-300 mt-2">
                                                    {{ desc.txt }}
                                                </p>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>                                 
                                <!-- ** -->
                                <mat-divider class="py-2"></mat-divider>                                
                          </mat-tab>                       
                      <!-- ##########################################################  -->
                           <mat-tab label="Atributos Flexibles"  *ngIf="flexibleAttributesValue.length">
                                <mat-divider class="py-2"></mat-divider>
                                <!-- ** -->
                                    <!-- FLEXIBLE ATTRIBUTES -->
                                    <div class="grid grid-cols-3 gap-4" *ngIf="flexibleAttributesValue.length">
                                        <mat-form-field class="w-full" *ngFor="let flex of flexibleAttributesValue">
                                            <mat-label>{{ flex.NAME_PARAM }}</mat-label>
                                            <input matInput readonly [value]="flex.VALUE_FLEXIBLE_ATTRIBUTES"/>
                                        </mat-form-field>
                                    </div>                                 
                                <!-- ** -->
                                <mat-divider class="py-2"></mat-divider>                                
                          </mat-tab>                           
                      <!-- ##########################################################  -->  
                 </mat-tab-group>                

             </div>
             <div *ngIf="interaction.FLAG_END != 'Y'">
                 <mat-tab-group #tabsOrder  [selectedIndex]="matTabOrderSelected">
                      <!-- ##########################################################  -->
                           <mat-tab label="Interacción" >
                                <mat-divider class="py-2"></mat-divider>
                                <!-- ** -->
                                    <mat-form-field class="w-full" *ngIf="interaction.FLAG_END !== 'Y'">
                                        <textarea
                                            matInput
                                            formControlName="txt"
                                            #txt
                                            maxlength="500"
                                            cdkTextareaAutosize
                                            cdkAutosizeMinRows="5"
                                            cdkAutosizeMaxRows="15"
                                            class="leading-5"
                                        ></textarea>
                                        <mat-hint align="end">{{ txt.value?.length || 0 }}/500</mat-hint>
                                    </mat-form-field>    
                                     <br>
                                    <button mat-raised-button color="primary" [disabled]="casosForm.invalid" *ngIf="interaction.FLAG_END !== 'Y' " (click)="update()">Actualizar Caso</button>
                                <!-- ** -->
                                <mat-divider class="py-2"></mat-divider>                                
                          </mat-tab>
                      <!-- ##########################################################  -->
                           <mat-tab label="Interacciones previas" >
                                <mat-divider class="py-2"></mat-divider>
                                <!-- ** -->
                                    <div class="space-y-4">
                                        <mat-card *ngFor="let desc of interaction.J_CUSTOMER_INTERACTION" class="interaction-card">
                                            <mat-card-header>
                                                <mat-card-title class="text-base font-medium flex items-center gap-2">
                                                    <mat-icon svgIcon="person" class="opacity-70"></mat-icon>
                                                    {{ desc.by }}
                                                </mat-card-title>
                                                <mat-card-subtitle>{{ desc.date | date:'medium' }}</mat-card-subtitle>
                                            </mat-card-header>

                                            <mat-card-content>
                                                <p class="leading-relaxed text-gray-700 dark:text-gray-300 mt-2">
                                                    {{ desc.txt }}
                                                </p>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>                                 
                                <!-- ** -->
                                <mat-divider class="py-2"></mat-divider>                                
                          </mat-tab>                       
                      <!-- ##########################################################  -->
                           <mat-tab label="Atributos Flexibles"  *ngIf="flexibleAttributesValue.length">
                                <mat-divider class="py-2"></mat-divider>
                                <!-- ** -->
                                    <!-- FLEXIBLE ATTRIBUTES -->
                                    <div class="grid grid-cols-3 gap-4" *ngIf="flexibleAttributesValue.length">
                                        <mat-form-field class="w-full" *ngFor="let flex of flexibleAttributesValue">
                                            <mat-label>{{ flex.NAME_PARAM }}</mat-label>
                                            <input matInput readonly [value]="flex.VALUE_FLEXIBLE_ATTRIBUTES"/>
                                        </mat-form-field>
                                    </div>                                 
                                <!-- ** -->
                                <mat-divider class="py-2"></mat-divider>                                
                          </mat-tab>                           
                      <!-- ##########################################################  -->  
                 </mat-tab-group>

            </div>
            <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% -->             
        <!-- ============================================ -->             
    </div>
</form>
<!-- ############################################################## -->
</div>